// src/data/featureData.ts

export interface Feature {
    id: string; // Unique identifier (e.g., "feature-1-linkedin")
    imageSrcDesktop: string; // Path to the image relative to the public folder (e.g., "/images/features/linkedin-gallery.webp")
    imageSrcMobile: string;
    imageAltText: string; // Descriptive alt text for accessibility
    imageWidth: number; // The intrinsic width of the optimized image file (e.g., 1760)
    imageHeight: number; // The intrinsic height of the optimized image file (e.g., 1145)
    annotationText: string; // The text content for the annotation box for this feature
  }
  
  export const features: Feature[] = [
    {
      id: "feature-1-linkedin",
      // Note: Using "1_linkedin_feature.webp" assuming you rename the file to avoid spaces.
      // If you keep the space, use "/images/features/1_LinkedIn feature.webp" but renaming is recommended.
      imageSrcDesktop: "/images/features/1_linkedin_feature.webp",
      imageSrcMobile: "/images/features/1_linkedin_feature_mobile.webp",
      imageAltText: "A grid of LinkedIn profile photos.",
      imageWidth: 1760,
      imageHeight: 1314,
      annotationText: "Analyzed thousands of LinkedIn photos to find trends in facial expressions across industries",
    }, // <--- MAKE SURE THIS COMMA IS HERE
  
    // PASTE THE NEW FEATURE OBJECT HERE:
    {
      id: "feature-2-tweets",
      imageSrcDesktop: "/images/features/2_angry_politicians_feature.webp",
      imageSrcMobile: "/images/features/2_angry_politicians_feature_mobile.webp", 
      imageAltText: "Four tweets from angry politicians",
      imageWidth: 1760,
      imageHeight: 1046,
      annotationText: "Used natural language processing to analyze two million tweets from 584 politicians, to see who is angriest",
    },
    
    {
        id: "feature-3-spotify",
        imageSrcDesktop: "/images/features/3_spotify_feature.webp",
        imageSrcMobile: "/images/features/3_spotify_feature_mobile.webp",
        imageAltText: "Happy playlists from Spotify",
        imageWidth: 1760,
        imageHeight: 1119,
        annotationText: "Analyzed hundreds of Spotify playlists associated with happiness and positivity, to see which songs appear most often",
    },

    {
        id: "feature-4-concerts",
        imageSrcDesktop: "/images/features/4_concerts_feature.webp",
        imageSrcMobile: "/images/features/4_concerts_feature_mobile.webp",
        imageAltText: "Images of Bono, Drake and Bruno Mars",
        imageWidth: 1760,
        imageHeight: 1200,
        annotationText: "Compared average ticket prices and show lengths for 200 popular artists to determine which concerts are most expensive per minute",
    },

    {
        id: "feature-5-glassdoor",
        imageSrcDesktop: "/images/features/5_glassdoor_feature.webp",
        imageSrcMobile: "/images/features/5_glassdoor_feature_mobile.webp",
        imageAltText: "Three pages of Glassdoor reviews",
        imageWidth: 1760,
        imageHeight: 1200,
        annotationText: "Analyzed three million Glassdoor reviews to see at which companies people complain the most about how much they're paid",
    },

    {
        id: "feature-6-ceos",
        imageSrcDesktop: "/images/features/6_smartest_ceos_feature.webp",
        imageSrcMobile: "/images/features/6_smartest_ceos_feature_mobile.webp",
        imageAltText: "Jensen Huang delivering talk on YouTube",
        imageWidth: 1760,
        imageHeight: 1243,
        annotationText: "Used AI to examine hundreds of hours of commentary made by 100 prominent CEOs, to measure signs of intelligence in their speech",
    },

    {
        id: "feature-7-airbnb",
        imageSrcDesktop: "/images/features/7_airbnb_feature.webp",
        imageSrcMobile: "/images/features/7_airbnb_feature_mobile.webp",
        imageAltText: "Price breakdowns for three Airbnb listings",
        imageWidth: 1760,
        imageHeight: 1055,
        annotationText: "Analyzed 32,000 Airbnb listings to reveal in which vacation markets hosts charge the highest cleaning fees",
    },

    {
        id: "feature-8-chinawok",
        imageSrcDesktop: "/images/features/8_china_wok_feature.webp",
        imageSrcMobile: "/images/features/8_china_wok_feature_mobile.webp",
        imageAltText: "Collage of signs from China Wok restaurants",
        imageWidth: 1760,
        imageHeight: 1056,
        annotationText: "Analyzed more than 300,000 restaurant names across the U.S. to determine which are most common",
    },

    {
        id: "feature-9-iphone",
        imageSrcDesktop: "/images/features/9_iphone_feature.webp",
        imageSrcMobile: "/images/features/9_iphone_feature_mobile.webp",
        imageAltText: "Images of Bono, Drake and Bruno Mars",
        imageWidth: 1760,
        imageHeight: 1200,
        annotationText: "Asked 700 iPhone users to guess how much time they spend on their phones, then checked the guesses against their actual screen time data",
    },
  ];